import { tint } from 'polished'
import styled from 'styled-components'

interface IDragOverlayStyledProps {}

export const DragOverlayStyled = styled.div<IDragOverlayStyledProps>`
  font-size: ${(props) =>
    props.theme.typography.pxToRem(props.theme.fontSizes.body1)};

  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;

  pointer-events: none;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${(props) => props.theme.space.medium};

  background: ${(props) => tint(0.3, props.theme.colors.aquamarine)};
  border: 1px dashed ${(props) => props.theme.colors.content.border};
`
